module.exports = __webpack_public_path__ + "static/media/flag_es.fb893cb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/flashcard/flag_es.svg
// module id = 131
// module chunks = 0